import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { ALL_CONFIG_FLAG_PROPERTIES, getOverriddenConfigFlagStates } from '../config';
import { PANEL_ITEM_PADDING_CSS } from '../panels/panelItem';
import { YELLOW_COLOR } from '../styles/colors';
import { getOnOffBooleanLabel } from '../utils/utils';
const CONTAINER_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    background-color: rgba(0, 0, 0, 0.5);
  `);
export const OverriddenConfigFlagsDisplayContainer = () => {
    const overriddenConfigFlagStates = getOverriddenConfigFlagStates();
    if (!Object.keys(overriddenConfigFlagStates).length) {
        return null;
    }
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(Typography, { component: 'div', children: "OVERRIDES:" }), Object.entries(overriddenConfigFlagStates).map(([configFlag, isEnabled]) => (_jsxs(Typography, { component: 'div', css: css `
            color: ${YELLOW_COLOR};
          `, children: [ALL_CONFIG_FLAG_PROPERTIES[configFlag].name || configFlag, ": ", getOnOffBooleanLabel(isEnabled)] }, configFlag)))] }));
};
